<template>
  <div class="scanlist">
    <div class="header">
      <div class="header_section">
        <router-link to="/profile" class="header_element header_icone mobile">
          <!--          <font-awesome-icon color="#00d7fe"  :icon="['fas','arrow-left']"/>-->
          <font-awesome-icon color="#00d7fe" class="reverse mobile" icon="angle-right"/>
        </router-link>
        <h1 class="header_element">SCAN LIST</h1>
      </div>
    </div>

    <div class="content_container">
      <nav class="selection-list">
        <h3 class="section-choice " data-selection="all" :class="{'current':selection==='all'}" @click="getList">
          Tous</h3>
        <h3 class="section-choice" data-selection="scan" :class="{'current':selection==='scan'}" @click="getList">Mes
          Scans</h3>
        <h3 class="section-choice" data-selection="scanned" :class="{'current':selection==='scanned'}" @click="getList">
          On Me Scan</h3>
      </nav>
      <div v-if="scanList && scanList.length>0">
        <transition-group class="scanlist_section" name="list" enter-active-class="animated fadeIn">
          <div class="scan" v-for="(scan,index) in scanList" :key="index+'-p'">
            <div class="is_scanned"><span>{{ scan.user_scanned.name }}</span><img :src="scan.user_scanned.avatar"
                                                                                  alt="">
            </div>
            <img :src="scan.product_tatouage" alt="">
            <div class="do_scan"><img :src="scan.user.avatar" alt=""><span>{{ scan.user.name }}</span></div>
          </div>
        </transition-group>
      </div>
      <div class="empty-case" v-else>
        <div class="empty">AUCUN SCAN</div>
      </div>
    </div>

  </div>
</template>
<script>
import {store} from '../store/store';
import {mapState, mapActions} from "vuex";

export default {
  name: 'ScanList',
  data() {
    return {
      user: store.getters.getUser,
      scanList: null,
      objectList: null,
      selection: 'all'
    }
  },
  methods: {
    ...mapActions([
      'getUserScan',
    ]),
    getList(e) {
      this.selection = e.target.dataset.selection;
      let userId = this.user.id;
      switch (this.selection) {
        case 'scan':
          this.scanList = this.objectList.filter(function (el) {
            return el.id_user === userId
          })
          break;
        case 'scanned':
          this.scanList = this.objectList.filter(function (el) {
            return el.id_user_scanned === userId
          })
          break;
        default:
          this.scanList = this.objectList
      }


    }

  },
  computed: {
    ...mapState([
      "masks",
    ])
  },
  mounted() {
    !localStorage.getItem('user') && this.$router.push({name: "login", params: {type: 'connexion'}});
    this.getUserScan().then(res => {
      this.objectList = res;
      this.scanList = this.objectList;

    })
  }
}
</script>
<style scoped>

.header {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}

.scanlist {
  z-index: 1;
  background: #fff;
  margin-bottom: 40px;
}

.header_icone {
  font-size: 30px;
  /*line-height: 80px;*/
}

.header_section {
  display: flex;
  align-items: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}

.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}


.content_container {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

nav.selection-list {
  display: flex;
  justify-content: space-between;
  width: 60%;

}

nav.selection-list .section-choice {
  display: inline-flex;
  text-align: center;
  color: var(--main-color);
  transition: .3s;
}

nav.selection-list .section-choice:hover {
  border-bottom: 2px solid var(--main-color);
  cursor: pointer;

}

nav.selection-list .section-choice.current {
  border-bottom: 2px solid var(--main-color);
}


.scanlist_section {
  display: flex;
}

.scanlist_section .scan {
  width: 30%;
  margin: 10px;
  position: relative;
  border: 2px solid var(--main-color);
  border-radius: 5px;
}

.scanlist_section .scan .do_scan, .scanlist_section .scan .is_scanned {
  display: flex;
  position: absolute;
  width: 100%;
  height: 30px;
  align-items: center;
}

.scanlist_section .scan .do_scan {
  left: -10px;
  bottom: -15px;
}

.scanlist_section .scan .is_scanned {
  right: -10px;
  top: -15px;
  justify-content: end;
}

.scanlist_section .scan .do_scan img, .scanlist_section .scan .is_scanned img {
  border-radius: 50%;
  border: 2px solid var(--main-color);
  width: 20%;
  position: absolute;
}

.scanlist_section .scan .do_scan span {
  margin-left: 18%;
}

.scanlist_section .scan .is_scanned span {
  margin-right: 18%;
}

.scanlist_section .scan .do_scan span, .scanlist_section .scan .is_scanned span {
  border-radius: 5px;
  border: 2px solid var(--main-color);
  background: #fff;
  padding: 5px 10px;

}

.scanlist_section .scan img {
  width: 100%;
}

.empty-case {
  display: flex;
}

.empty-case > * {
  color: #bebebe;
  font-family: Poppins;
  padding: 20px;
  margin: auto;
}


.content_element {
  color: white;
  border-radius: 20px;
  background-color: #00d6ff;
  height: 70px;
  display: flex;
  width: 90%;
  margin: 10px auto;
  justify-content: space-between;
}

a {
  text-decoration: none;
}

a.addinsta {
  color: #00a6d9;
}

@media screen and (max-width: 750px) {

  nav.selection-list {
    width: 100%;
  }
}
</style>
